import React from 'react';
import PropTypes from 'prop-types';
import ImageFigure from 'components/Models/ImageFigure/ImageFigure';
import NewImageBlock from 'components/NewImageBlock';
import Collapse from 'components/Collapse';
import cn from "classnames";

import './TextBlock.scss';

const TextBlock = ({
    heading,
    image,
    text,
    textExpandable,
    blockId,
    anchorId,
    className,
    place,
    lang
}) => (
    <div className={cn("text-block", {
        [className]: className,
        ['text-block_place_' + place]: place,
    })} data-block={blockId} id={anchorId}> 
        {heading && <h2 className="text-block__heading">{heading}</h2>}
        {image && (
            <NewImageBlock 
                image={image} 
                inRichText 
                className="text-block__image" 
            />
        )}
        {text && (
            <div dangerouslySetInnerHTML={{ __html: text }} />
        )}
        {textExpandable && (
            <Collapse expandLabel={lang.expandLabel} collapseLabel={lang.collapseLabel}>
                <div dangerouslySetInnerHTML={{ __html: textExpandable }} />
            </Collapse>
        )}
    </div>
);

TextBlock.propTypes = {
    className: PropTypes.string,
    heading: PropTypes.string,
    image: PropTypes.shape(ImageFigure.propTypes),
    text: PropTypes.string,
    textExpandable: PropTypes.string,
    blockId: PropTypes.number,
    anchorId: PropTypes.string,
    place: PropTypes.oneOf(['investor-page']),
    lang: PropTypes.shape({
        expandLabel: PropTypes.string.isRequired,
        collapseLabel: PropTypes.string.isRequired,
    }),
};

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/TextBlock/TextBlock.jsx